const ReadOnlyField = ({ label, value, multiline = false, inline = false }) => {
  const control = multiline ? (
    <textarea className="form-control mt-1" rows="4" value={value ?? ""} disabled readOnly />
  ) : (
    <input type="text" className="form-control" value={value ?? ""}  disabled readOnly />
  );

  if (inline) {
    return (
      <div className="d-flex align-items-center mb-4">
        <label className="form-label mb-0 w-20">{label}</label>
        <div style={{ flex: 1 }}>{control}</div>
      </div>
    );
  }
  return (
    <div className="mt-2">
      <label className="form-label">{label}</label>
      {control}
    </div>
  );
};

export default ReadOnlyField;